<template>
  <div class="app-shell home-page tool-page">
    <div class="app-shell__main">
      <AppHeader />

      <main class="home-main tool-main">
        <section class="pay-section tool-hero-section tool-page-hero">
          <div class="tool-hero-grid">
            <div class="tool-hero-copy">
              <span class="tool-eyebrow">Member Center</span>
              <h1 class="pay-title">会员中心</h1>
              <p class="pay-description">
                选择会员套餐或按需充值次数，更顺畅地使用全部工具能力。
              </p>
              <div class="tool-copy-pills">
                <span>会员无限次使用核心工具</span>
                <span>积分按需购买，使用更灵活</span>
                <span>支持微信扫码完成支付</span>
              </div>
            </div>

            <div class="tool-workbench tool-workbench--pay">
              <div class="pay-master-card">
                <div class="user-info-card" v-if="userInfo.id">
                  <div class="user-avatar">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                      <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                  </div>
                  <div class="user-details">
                    <div class="user-id">账号ID: SYF{{ String(userInfo.id).padStart(6, '0') }}</div>
                    <div class="user-status" v-if="userInfo.member">
                      <span class="status-badge">VIP会员</span>
                      <span class="status-date">到期时间: {{ formatTime(new Date(userInfo.deadlineTime)) }}</span>
                    </div>
                    <div class="user-status" v-else>
                      <span class="status-badge gray">普通用户</span>
                    </div>
                  </div>
                </div>

                <div class="pay-content">
                <div class="pay-column">
                  <h2 class="column-title">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" class="icon">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                      <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                    会员套餐
                    <span class="subtitle">无限次使用，尊享特权</span>
                  </h2>
                  <div class="options-grid">
                    <div
                      v-for="item in memberOptions"
                      :key="item.id"
                      class="option-card"
                      :class="{ active: selectedType === 'member' && selectedId === item.id }"
                      @click="selectMember(item)"
                    >
                      <div>
                        <div class="option-name">{{ item.name }}</div>
                        <div class="option-note">适合高频使用</div>
                      </div>
                      <div class="option-price">
                        <span class="currency">¥</span>
                        <span class="amount">{{ item.price * 0.01 }}</span>
                      </div>
                      <div class="check-icon" v-if="selectedType === 'member' && selectedId === item.id">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="pay-column">
                  <h2 class="column-title">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" class="icon">
                      <circle cx="12" cy="12" r="10"></circle>
                      <polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                    积分充值
                    <span class="subtitle">按需购买，永久有效</span>
                  </h2>
                  <div class="options-grid">
                    <div
                      v-for="item in pointsOptions"
                      :key="item.id"
                      class="option-card"
                      :class="{ active: selectedType === 'points' && selectedId === item.id }"
                      @click="selectPoints(item)"
                    >
                      <div>
                        <div class="option-name">{{ item.name }}</div>
                        <div class="option-note">适合偶尔处理素材</div>
                      </div>
                      <div class="option-price">
                        <span class="currency">¥</span>
                        <span class="amount">{{ item.price * 0.01 }}</span>
                      </div>
                      <div class="check-icon" v-if="selectedType === 'points' && selectedId === item.id">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                </div>

                <div class="pay-action-bar" v-if="selectedItem">
                  <div class="summary-info">
                    <span class="label">当前选择：</span>
                    <span class="value">{{ selectedItem.name }}</span>
                    <span class="price">¥{{ selectedItem.price * 0.01 }}</span>
                    <div class="deadline-info" v-if="selectedType === 'member'">
                      预计到期: {{ deadlineTime }}
                    </div>
                  </div>
                  <button class="pay-button" @click="handlePay">
                    立即支付
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>

    <div v-if="showPayModal" class="pay-qr-overlay" @click.self="closePayModal">
      <div class="pay-qr-container">
        <div class="pay-qr-header">
          <div class="pay-qr-title">微信扫码支付</div>
          <button class="pay-qr-close" @click="closePayModal">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
        <div class="pay-qr-body">
          <div v-if="payQrImage" class="pay-qr-img-wrapper">
            <img :src="payQrImage" class="pay-qr-img" />
          </div>
          <div v-else class="pay-qr-loading">二维码生成中...</div>
          <div class="pay-qr-hint">请使用手机微信扫一扫完成支付</div>
          <div class="pay-qr-status" v-if="payStatusText">{{ payStatusText }}</div>
          <div class="pay-qr-order" v-if="payOrderNo">订单号：{{ payOrderNo }}</div>
        </div>
      </div>
    </div>

    <AppFooter />
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { showToast } from 'vant'
import { useRoute } from 'vue-router'
import { getUserInfo } from '@/api/user'
import { getVipGoodsList, commitNativeVipOrder, getWechatPayStatus } from '@/api/vip'
import { formatTime } from '@/utils/date'
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'

const route = useRoute()
let token = route.query.token

// State
const pointsOptions = ref([])
const memberOptions = ref([])
const userInfo = ref({})
const deadlineTime = ref('')
const selectedType = ref('member') // 'points' | 'member'
const selectedId = ref('2')
const selectedItem = ref({})

const showPayModal = ref(false)
const payQrImage = ref('')
const payOrderNo = ref('')
const payStatusText = ref('')
const isCreatingOrder = ref(false)
const pollingTimer = ref(null)
const pollingCount = ref(0)

onMounted(() => {
  if (token) {
    localStorage.setItem('token', token)
  } else {
    // Try to get token from URL if not in query params
    const tokenMatch = window.location.href.match(/token=([^&]*)/)
    if (tokenMatch) {
      token = tokenMatch[1]
      localStorage.setItem('token', token)
    }
  }

  getVipGoodsList()
    .then(res => {
      pointsOptions.value = res.times
      memberOptions.value = res.members
      
      // Default select first member option
      if (memberOptions.value.length > 0) {
        selectedId.value = memberOptions.value[0].id
        selectedItem.value = memberOptions.value[0]
      }
      
      getUserInfo()
        .then(res => {
          userInfo.value = res
          caculateDeadlineTime()
        })
        .catch(err => {
          console.error(err)
        })
    })
    .catch(err => {
      console.error(err)
    })
})

onBeforeUnmount(() => {
  stopPolling()
})

const selectPoints = (item) => {
  selectedType.value = 'points'
  selectedId.value = item.id
  selectedItem.value = item
  caculateDeadlineTime()
}

const selectMember = (item) => {
  selectedType.value = 'member'
  selectedId.value = item.id
  selectedItem.value = item
  caculateDeadlineTime()
}

const caculateDeadlineTime = () => {
  if (!userInfo.value || !selectedItem.value) return
  const currentMis = new Date().getTime()
  const startTime = userInfo.value.deadlineTime < currentMis ? currentMis : userInfo.value.deadlineTime
  // Assuming value is in days
  if (selectedType.value === 'member') {
    deadlineTime.value = formatTime(new Date(startTime + (selectedItem.value.value * 24 * 60 * 60 * 1000)))
  } else {
    deadlineTime.value = ''
  }
}

const refreshUserInfo = async () => {
  try {
    const info = await getUserInfo()
    userInfo.value = info || {}
    caculateDeadlineTime()
  } catch (e) {
    console.error(e)
  }
}

const loadQrCodeLib = () => {
  if (window.QRCode && window.QRCode.toDataURL) return Promise.resolve(window.QRCode)
  return new Promise((resolve, reject) => {
    const existing = document.querySelector('script[data-qrcode-lib="1"]')
    if (existing) {
      const start = Date.now()
      const timer = setInterval(() => {
        if (window.QRCode && window.QRCode.toDataURL) {
          clearInterval(timer)
          resolve(window.QRCode)
        } else if (Date.now() - start > 10000) {
          clearInterval(timer)
          reject(new Error('qrcode lib load timeout'))
        }
      }, 50)
      return
    }
    const s = document.createElement('script')
    s.dataset.qrcodeLib = '1'
    s.src = 'https://unpkg.com/qrcode@1.4.4/build/qrcode.min.js'
    s.onload = () => resolve(window.QRCode)
    s.onerror = () => reject(new Error('qrcode lib load error'))
    document.head.appendChild(s)
  })
}

const stopPolling = () => {
  if (pollingTimer.value) {
    clearInterval(pollingTimer.value)
    pollingTimer.value = null
  }
  pollingCount.value = 0
}

const closePayModal = async () => {
  stopPolling()
  showPayModal.value = false
  payQrImage.value = ''
  payOrderNo.value = ''
  payStatusText.value = ''
  await refreshUserInfo()
}

const startPolling = (no) => {
  stopPolling()
  pollingTimer.value = setInterval(async () => {
    pollingCount.value += 1
    if (pollingCount.value > 600) {
      payStatusText.value = '支付超时，请重新发起'
      stopPolling()
      await refreshUserInfo()
      return
    }
    try {
      const res = await getWechatPayStatus(no)
      if (!res) return
      payStatusText.value = res.desc || res.state || ''
      const state = res.state || ''
      if (state === 'SUCCESS') {
        stopPolling()
        closePayModal()
        showToast('支付成功')
      } else if (state === 'CLOSED' || state === 'REVOKED' || state === 'PAYERROR') {
        stopPolling()
        await refreshUserInfo()
      }
    } catch (e) {
      console.error(e)
    }
  }, 2000)
}

const handlePay = async () => {
  if (!selectedItem.value) return showToast('请选择套餐')

  if (isCreatingOrder.value) return
  isCreatingOrder.value = true
  showPayModal.value = true
  payQrImage.value = ''
  payOrderNo.value = ''
  payStatusText.value = '等待支付...'
  try {
    const res = await commitNativeVipOrder(selectedItem.value.id)
    payOrderNo.value = res.no
    const qrLib = await loadQrCodeLib()
    payQrImage.value = await qrLib.toDataURL(res.url, { width: 260, margin: 1 })
    startPolling(res.no)
  } catch (e) {
    console.error(e)
    closePayModal()
    showToast(e?.message || '发起支付失败')
  } finally {
    isCreatingOrder.value = false
  }
}
</script>

<style scoped>
.home-main {
  width: 100%;
  margin: 0;
  padding: 0;
}

.pay-section .tool-hero-grid {
  gap: 18px;
}

.pay-section .tool-hero-copy {
  gap: 12px;
}

.pay-title {
  margin: 0;
  font-size: 54px;
  line-height: 1.02;
  letter-spacing: -0.05em;
  color: var(--ink);
}

.pay-description {
  margin: 0;
  max-width: 640px;
  color: var(--muted);
  line-height: 1.9;
}

.tool-workbench--pay {
  width: 100%;
  padding: 24px;
}

.pay-master-card {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.user-info-card {
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 20px;
  background: linear-gradient(135deg, rgba(91, 107, 255, 0.08), rgba(47, 128, 237, 0.04));
  border: 1px solid rgba(91, 107, 255, 0.14);
  border-radius: 24px;
}

.user-avatar {
  width: 60px;
  height: 60px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: linear-gradient(135deg, #5b6bff 0%, #2f80ed 100%);
  box-shadow: 0 18px 30px rgba(79, 70, 229, 0.18);
}

.user-avatar svg {
  width: 30px;
  height: 30px;
}

.user-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.user-id {
  font-size: 18px;
  font-weight: 700;
  color: var(--ink);
}

.user-status {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 999px;
  background: rgba(245, 158, 11, 0.14);
  color: #b45309;
  font-size: 13px;
  font-weight: 700;
}

.status-badge.gray {
  background: rgba(27, 42, 65, 0.06);
  color: var(--muted);
}

.status-date {
  color: var(--muted);
  font-size: 14px;
}

.pay-content {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
}

.pay-column {
  padding: 22px;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.68);
  border: 1px solid rgba(223, 230, 242, 0.84);
}

.column-title {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin: 0 0 16px;
  font-size: 22px;
  font-weight: 800;
  color: var(--ink);
}

.column-title .icon {
  width: 24px;
  height: 24px;
  color: var(--brand);
}

.column-title .subtitle {
  color: var(--muted);
  font-size: 14px;
  font-weight: 500;
  margin-left: auto;
}

.options-grid {
  display: grid;
  gap: 14px;
}

.option-card {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 18px 20px;
  border-radius: 22px;
  border: 1px solid rgba(223, 230, 242, 0.96);
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 10px 20px rgba(50, 71, 117, 0.04);
  cursor: pointer;
  transition: transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
}

.option-card:hover {
  transform: translateY(-2px);
  border-color: rgba(79, 70, 229, 0.24);
  box-shadow: 0 18px 30px rgba(50, 71, 117, 0.08);
}

.option-card.active {
  background: linear-gradient(135deg, rgba(91, 107, 255, 0.1), rgba(47, 128, 237, 0.08));
  border-color: rgba(79, 70, 229, 0.32);
  box-shadow: 0 18px 30px rgba(79, 70, 229, 0.12);
}

.option-name {
  font-size: 18px;
  font-weight: 700;
  color: var(--ink);
}

.option-note {
  margin-top: 6px;
  font-size: 13px;
  color: var(--muted);
}

.option-price {
  display: flex;
  align-items: baseline;
  color: var(--brand);
}

.currency {
  font-size: 16px;
  font-weight: 700;
}

.amount {
  font-size: 32px;
  font-weight: 800;
  letter-spacing: -0.04em;
}

.check-icon {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 18px;
  height: 18px;
  color: var(--brand);
}

.check-icon svg {
  width: 100%;
  height: 100%;
}

.pay-action-bar {
  position: sticky;
  bottom: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 20px;
  border-radius: 24px;
  border: 1px solid rgba(223, 230, 242, 0.96);
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 18px 30px rgba(50, 71, 117, 0.08);
  backdrop-filter: blur(16px);
}

.summary-info {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  color: var(--muted);
}

.summary-info .value {
  color: var(--ink);
  font-weight: 700;
}

.summary-info .price {
  color: var(--brand);
  font-size: 22px;
  font-weight: 800;
}

.deadline-info {
  color: var(--muted);
  font-size: 14px;
}

.pay-button {
  border: none;
  border-radius: 999px;
  padding: 14px 24px;
  color: #fff;
  background: linear-gradient(135deg, #5b6bff 0%, #2f80ed 100%);
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 18px 30px rgba(79, 70, 229, 0.22);
}

.pay-qr-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(15, 23, 42, 0.42);
}

.pay-qr-container {
  width: min(100%, 420px);
  overflow: hidden;
  border-radius: 28px;
  border: 1px solid rgba(255, 255, 255, 0.9);
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.22);
  backdrop-filter: blur(18px);
}

.pay-qr-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px;
  border-bottom: 1px solid rgba(223, 230, 242, 0.96);
}

.pay-qr-title {
  font-size: 17px;
  font-weight: 700;
  color: var(--ink);
}

.pay-qr-close {
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 50%;
  background: rgba(15, 23, 42, 0.05);
  color: var(--ink);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.pay-qr-close svg {
  width: 18px;
  height: 18px;
}

.pay-qr-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 24px;
}

.pay-qr-img-wrapper,
.pay-qr-loading {
  width: 280px;
  height: 280px;
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 1px solid rgba(223, 230, 242, 0.96);
}

.pay-qr-img {
  width: 260px;
  height: 260px;
  object-fit: contain;
}

.pay-qr-loading,
.pay-qr-hint,
.pay-qr-order {
  color: var(--muted);
}

.pay-qr-status {
  color: var(--ink);
  font-weight: 700;
}

@media (max-width: 900px) {
  .pay-title {
    font-size: 38px;
  }

  .tool-workbench--pay {
    padding: 18px;
  }

  .pay-content {
    grid-template-columns: 1fr;
  }

  .pay-action-bar {
    flex-direction: column;
    align-items: stretch;
  }

  .pay-button {
    width: 100%;
  }
}

@media (max-width: 720px) {
  .user-info-card {
    flex-direction: column;
    align-items: flex-start;
  }

  .column-title .subtitle {
    margin-left: 0;
  }

  .pay-qr-img-wrapper,
  .pay-qr-loading {
    width: 100%;
    max-width: 360px;
    height: auto;
    aspect-ratio: 1 / 1;
  }

  .pay-qr-img {
    width: calc(100% - 20px);
    height: calc(100% - 20px);
  }
}
</style>
